import EmployeeDetails from "../../../../components/company/workforce/all-employees/employee-details";

export default function EmployeeDetailPage(){
    return <EmployeeDetails/>
}